export class NativeStreamYesNoCriteria {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "trueMeans",
            "baseName": "trueMeans",
            "type": "string",
            "format": ""
        },
        {
            "name": "falseMeans",
            "baseName": "falseMeans",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamYesNoCriteria.attributeTypeMap;
    }
    constructor() {
    }
}
